import React from 'react';
import { PageContentLayout, PageHeaderLayout } from '../../shared/layout';
import { Card, Col, Row, Empty, Typography, Select } from 'antd';
import { FilterOutlined, AuditOutlined } from '@ant-design/icons';
import { InvoiceView } from './components';
import { useHistory } from 'react-router-dom';
//style
import { cardMargin, cardBody, cardData } from '../../shared/globalStyling/style';

const { Text } = Typography;

const InvoiceMainView = ({
  invoiceList,
  invoiceFilterList,
  tableLoading,
  totalOverdue,
  setFilteredInfo,
  currentBalance,
  billingDetails,
}) => {
  const history = useHistory();

  const renderCard = (title, value, description) => (
    <Card
      style={{
        ...cardMargin,
        minHeight: '130px',
        height: 'auto',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
      }}
      bodyStyle={{
        ...cardBody,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '16px',
      }}
    >
      <Row style={{ marginBottom: '10px' }}>
        <Text
          type="secondary"
          style={{
            fontSize: '14px',
            wordBreak: 'break-word',
          }}
          className="card-title"
        >
          {title}
        </Text>
      </Row>
      <Row style={{ flex: 1, alignItems: 'center' }}>
        <Text
          strong
          style={{
            ...cardData,
            fontSize: '20px',
            wordBreak: 'break-word',
            lineHeight: '1.2',
          }}
          className="card-value"
        >
          {value}
        </Text>
      </Row>
      {description && (
        <Row style={{ marginTop: 'auto' }}>
          <Text
            type="secondary"
            style={{
              fontSize: '13px',
              wordBreak: 'break-word',
            }}
            className="card-description"
          >
            {description}
          </Text>
        </Row>
      )}
    </Card>
  );

  return (
    <React.Fragment>
      <PageHeaderLayout
        title="Invoices"
        titleIcon={
          <AuditOutlined
            style={{
              marginRight: '10px',
              fontSize: 20,
              color: 'lightgrey',
            }}
          />
        }
      />
      <PageContentLayout>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={8} xl={6}>
            {renderCard(
              'Advertiser Impressions',
              billingDetails.advertiserDetails.totalImpressionsSum,
              `Current Month: ${(
                (billingDetails.advertiserDetails.totalImpressionsSum / 1000) *
                0.75
              ).toFixed(2)} CPM: $0.75`
            )}
          </Col>
          <Col xs={24} sm={12} md={12} lg={8} xl={4}>
            {renderCard(
              'Publisher Domains',
              billingDetails.publisher.uniqueClicksTags,
              '$500 monthly per tag'
            )}
          </Col>
          <Col xs={24} sm={12} md={12} lg={8} xl={4}>
            {renderCard(
              'Publisher Funnel',
              billingDetails.publisher.nonPausedPublishers,
              '$50 monthly per domain'
            )}
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={5}>
            {renderCard('Current Balance', currentBalance)}
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={5}>
            {renderCard('Overdue Balance', totalOverdue)}
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
          <Col span={24}>
            <Card
              style={cardMargin}
              bodyStyle={cardBody}
              title="Invoices"
              loading={false}
              extra={
                <Select
                  suffixIcon={<FilterOutlined />}
                  defaultValue="UNPAID"
                  onChange={setFilteredInfo}
                  style={{ width: 120 }}
                  options={[
                    { value: 'All', label: 'All' },
                    { value: 'PAID', label: 'Paid' },
                    { value: 'UNPAID', label: 'Unpaid' },
                    { value: 'SCHEDULED', label: 'Scheduled' },
                    { value: 'CANCELED', label: 'Canceled' },
                    { value: 'REFUNDED', label: 'Refunded' },
                  ]}
                />
              }
            >
              {invoiceList && invoiceList.length !== 0 ? (
                <InvoiceView
                  invoiceList={invoiceList}
                  invoiceFilterList={invoiceFilterList}
                  loading={tableLoading}
                  history={history}
                />
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </Card>
          </Col>
        </Row>
      </PageContentLayout>
    </React.Fragment>
  );
};

export default InvoiceMainView;
